<template>
  <div id="nervousbreakdown">
    <div class="finishedFilter" v-show="isCleared">
      <p class="clearMessage">Thank you for your playing.</p>
      <div class="button" v-on:click="retry()">Again</div>
    </div>
    <div class="container" v-show="!isCleared">
      <div
        :class="card.class"
        class="card"
        v-for="card in cardObjects"
        :key="card.keyOfCard"
        v-on:click="selectCard(card)"
      >
        <div class="card_surface fill"></div>
        <div class="card_reverse fill">
          <div class="middle">{{ card.number }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NervousBreakdown",
  title: "神経衰弱",
  created() {
    this.initializeCards();
  },
  methods: {
    initializeCards() {
      for (var i = 1; i <= 10; i++) {
        for (var j = 1; j <= 2; j++) {
          this.cardObjects.push({
            number: i,
            isOpened: false,
            keyOfCard: i + "keyof" + j,
            class: "is-surface card_surface"
          });
        }
      }
      this.shuffleCards();
    },
    shuffleCards() {
      // fisher-yates algorithm
      // Math.random()は0〜1までのランダムな値を返す
      // indexをかけ、Floor関数を使用することでランダムな整数を返す。
      // random関数は、0以上1未満の値を返す。
      for (var i = this.cardObjects.length - 1; i > 0; i--) {
        var r = Math.floor(Math.random() * (i + 1));
        var tmp = this.cardObjects[i];
        this.cardObjects[i] = this.cardObjects[r];
        this.cardObjects[r] = tmp;
      }
    },
    selectCard(card) {
      // Card is already opened or finished
      if (
        this.isSameKey(card) ||
        this.restoringFlag ||
        card.isOpened ||
        this.isFinishedNumber(card)
      )
        return;
      // Judge card
      this.judgeCard(card);
    },
    judgeCard(card) {
      if (this.chosenIdx == null) {
        // frist choose
        console.log("single");
        this.openSingleCard(card);
      } else if (this.isSameNumber(card)) {
        // success pattern
        console.log("finish");
        this.finishingCards(card);
      } else {
        // failed pattern
        console.log("restore");
        this.restoreCards(card);
      }
    },
    isSameKey(card) {
      if (this.getSavedCardObject() == null) return false;
      return card.keyOfCard == this.getSavedCardObject().keyOfCard;
    },
    isSameNumber(card) {
      return card.number == this.getSavedCardObject().number;
    },
    openSingleCard(card) {
      this.chosenIdx = this.cardObjects.indexOf(card);
      card.isOpened = true;
      card.class = "is-reverse";
    },
    finishingCards(card) {
      card.isOpened = true;
      card.class = "is-reverse";
      this.openedNumbers.push(card.number);
      this.chosenIdx = null;
    },
    restoreCards(card) {
      card.isOpened = true;
      card.class = "is-reverse";
      const self = this;
      this.restoringFlag = true;
      setTimeout(
        () => {
          card.isOpened = false;
          card.class = "is-surface";
          const savedCard = self.getSavedCardObject();
          savedCard.isOpened = false;
          savedCard.class = "is-surface";
          self.chosenIdx = null;
          self.restoringFlag = false;
        },
        1500,
        self
      );
    },
    getSavedCardObject() {
      return this.cardObjects[this.chosenIdx];
    },
    isFinishedNumber(card) {
      return this.openedNumbers.indexOf(card.number) >= 0;
    },
    retry() {
      this.initializeClearedData();
      this.initializeCards();
    },
    initializeClearedData() {
      this.cardObjects.length = 0;
      this.openedNumbers.length = 0;
    }
  },
  data: () => ({
    cardObjects: [],
    chosenIdx: null,
    openedNumbers: [],
    restoringFlag: false
  }),
  computed: {
    isCleared() {
      return this.cardObjects.every(card => {
        return card.isOpened;
      });
    }
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  display: inline-flex;
  flex-flow: row wrap;
  justify-content: center;
}
.finishedFilter {
  width: 100%;
  height: 25vh;
  padding-top: 18vh;
  text-align: center;
  background-color: rgba(210, 210, 211, 0.8);
}
.card {
  position: relative;
  justify-content: center;
  align-items: center;
  margin: 5px 5px;
  flex-basis: 10vh;
  height: 15vh;
  padding: 10px;
  display: flex;
  transition: opacity 50ms 200ms;
}
/* 表面の表示 */
.is-surface .card_surface {
  background-color: gray;
  opacity: 1;
  transform: rotateY(0deg);
  transition: opacity 100ms 150ms, transform 300ms 150ms;
}
.is-surface .card_reverse {
  background-color: aqua;
  opacity: 0;
  transform: rotateY(90deg);
  transition: opacity 50ms 200ms, transform 300ms;
}

/* 裏面の表示 */
.is-reverse .card_surface {
  background-color: gray;
  opacity: 0;
  transform: rotateY(90deg);
  transition: opacity 50ms 200ms, transform 300ms;
}
.is-reverse .card_reverse {
  background-color: aqua;
  opacity: 1;
  transform: rotateY(0deg);
  transition: opacity 100ms 150ms, transform 300ms 150ms;
}
.fill {
  position: absolute;
  width: 100%;
  height: 100%;
}
.middle {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.clearMessage {
  margin-bottom: 15px;
}
.button {
  font-size: 50%;
  border-radius: 2px;
  padding: 6px;
  background-color: #ffffff;
  box-shadow: 1px 1px 4px gray;
}
.button:hover {
  border-radius: 2px;
  background-color: #d3d3d3;
  cursor: pointer;
  transition: all 300ms 0s ease;
  border: outset 1px rgb(181, 181, 233);
}
</style>